import { api } from '@/lib/api.js';
import { inFlightDedup } from '@/lib/inFlight.js';
import { pollOpts } from '@/lib/poll.js';

// Calls the aggregator endpoint built in Step 5:
//   GET /api/tracon/command-center
// Backend will join pipeline + per-deal quotes + activity log signals
// and return categorized buckets ready to render.
//
// Shape (target):
//   {
//     categories: {
//       need_info_from_client:   [{ deal, urgency, carriers, ... }],
//       ready_to_submit:         [...],
//       running_quotes:          [...],
//       need_to_present:         [...],
//       awaiting_client_decision:[...],
//       binding_in_progress:     [...],
//       need_to_send_docs:       [...],
//       invoice_and_remit:       [...],
//       inbound_requests:        [...]
//     },
//     generatedAt: ISO,
//     pipelineCount: number
//   }
//
// V1 fetches the whole board. V1.5 can add per-category lazy loading
// once data volumes justify it.

export function getCommandCenter({ poll = false } = {}) {
  return inFlightDedup('command-center', () => api.get('/api/tracon/command-center', pollOpts(poll)));
}
